export default __webpack_public_path__ + "static/media/like_filled.a6edf454.svg";